
import React from 'react';
import { Card, Box, Typography, Stack } from '@mui/material';

interface QuickStartCardProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  onClick: () => void;
}

export const QuickStartCard: React.FC<QuickStartCardProps> = ({
  icon,
  title,
  subtitle,
  onClick,
}) => {
  return (
    <Card
      onClick={onClick}
      sx={{
        padding: '30px 24px',
        borderRadius: '12px',
        border: '2px dashed var(--fx-surface-border, #E2E8F0)',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        backgroundColor: 'var(--fx-surface-base, #FFFFFF)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: 'none',
        '&:hover': {
          borderColor: 'var(--fx-surface-borderstrong, #CBD5E1)',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
          transform: 'translateY(-1px)',
        },
      }}
    >
      <Stack direction="row" spacing={2} alignItems="flex-start">
        {/* Icon container */}
        <Box
          sx={{
            fontSize: 24,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--fx-surface-texttertiary, #94A3B8)',
            flexShrink: 0,
            '& svg': {
              fontSize: '24px',
            },
          }}
        >
          {icon}
        </Box>

        {/* Text content */}
        <Stack spacing={0.5} sx={{ flex: 1 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 600,
              color: 'var(--fx-surface-text, #0F172A)',
              fontSize: '15px',
              lineHeight: 1.4,
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'var(--fx-surface-textsecondary, #64748B)',
              fontSize: '13px',
              lineHeight: 1.5,
            }}
          >
            {subtitle}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};